// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Title-module--bx--text-truncate--end--vgfUt";
export var bxTextTruncateFront = "Title-module--bx--text-truncate--front--AQyf9";
export var title = "Title-module--title--K9WM8";